import { CustomDetail, DateAvailabilityOut, TimeSlotResponseOut } from '../../../../api';

// An order page can mark individual time slots with a custom detail (in practice: the language the
// session is held in). When at least one slot on the page carries such a detail, slots that carry none
// are implicitly the default language, and we label them explicitly so the options read consistently.
export const hasAnyWidgetCustomTimeDetail = (dates: DateAvailabilityOut[]): boolean =>
  !!dates?.find((date) => date.times.find((time) => !!time.custom_details && time.custom_details[0]?.show_in_widget));

export const resolveWidgetCustomDetails = (
  timeSlot: TimeSlotResponseOut,
  hasCustomTimeDetailOnPage: boolean,
): CustomDetail[] | undefined => {
  if (hasCustomTimeDetailOnPage && timeSlot.custom_details && timeSlot.custom_details.length === 0) {
    return [
      {
        label: {
          en: 'Hebrew',
          he: 'עברית',
        },
        show_in_widget: true,
      },
    ];
  }
  return timeSlot.custom_details;
};
